import React from "react"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { Box } from "@mui/material"
import { AppIconChipToggle, AppFormGrid } from "@components"
import { useSignal } from "@preact/signals-react"
import {
	ReportDateMaxExecution,
	ReportDateMinExecution
} from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields/FrequencyNotification/DateRangeExecutionFields"


export default function () {

	const useDateRange = useSignal(!!reportFormData.peek().executionDateMin && !!reportFormData.peek().executionDateMax)

	return <AppFormGrid>
		<Box sx={{ gridColumn: '1 / -1' }}>
			<AppIconChipToggle
				aria-label="Execution dates"
				value={!!useDateRange.value}
				options={[
					{ value: false, label: 'Any date', icon: 'infinity' },
					{ value: true, label: 'Date range', icon: 'calendar-range' },
				]}
				onChange={value => useDateRange.value = value}
			/>
		</Box>
		<Box sx={{ gridColumn: 'span 4' }}>
			<ReportDateMinExecution useDateRange={useDateRange.value}/>
		</Box>
		<Box sx={{ gridColumn: 'span 4' }}>
			<ReportDateMaxExecution useDateRange={useDateRange.value}/>
		</Box>
	</AppFormGrid>
}
